import React, { FC } from 'react'

import { styled } from '@linaria/react'

import { ProfileNoImage } from 'components/block/ProfileNoImage/ProfileNoImage'
import { Typography } from 'components/designSystem/Typography/Typography'
import { GQLGender } from 'generated-graphql/graphql'

export const ProfileLocation: FC<{
  userId: number
  gender: GQLGender
  city: string
  region: string
  distance?: string
  photo?: string
}> = ({ userId, gender, distance, city, region, photo }) => {
  const _photo = photo ? (
    <Photo src={photo} />
  ) : (
    <NoPhoto userId={userId} gender={gender} />
  )

  const location = (
    <>
      {city}, <br />
      {region}
    </>
  )

  const title = distance || location
  const description = distance ? location : ''

  return (
    <Parent>
      <PhotoMarketMask data-name="location-photo">{_photo}</PhotoMarketMask>
      <Position>
        <Typography
          fontSize={24}
          fontWeight={700}
          tag="p"
          data-name="user-distances"
        >
          {title}
        </Typography>
        {description && (
          <Place
            fontSize={20}
            fontWeight={500}
            tag="p"
            data-name="user-location"
          >
            {description}
          </Place>
        )}
      </Position>
    </Parent>
  )
}

const Parent = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: var(--spacing-16px);
  gap: var(--spacing-16px);
  height: min-content;
`

const PhotoMarketMask = styled.div`
  width: 52px;
  height: 75px;
  overflow: hidden;
  position: relative;
  clip-path: polygon(
    100% 34.646%,
    100% 34.646%,
    99.923% 36.591%,
    99.693% 38.507%,
    99.315% 40.393%,
    98.794% 42.245%,
    98.132% 44.06%,
    97.335% 45.836%,
    96.406% 47.57%,
    95.349% 49.258%,
    94.169% 50.899%,
    92.869% 52.49%,
    92.869% 52.49%,
    91.867% 53.693%,
    89.136% 56.97%,
    85.092% 61.823%,
    80.152% 67.753%,
    74.73% 74.26%,
    69.241% 80.847%,
    64.102% 87.015%,
    59.728% 92.265%,
    56.534% 96.098%,
    54.936% 98.016%,
    54.936% 98.016%,
    54.582% 98.393%,
    54.184% 98.73%,
    53.746% 99.028%,
    53.275% 99.286%,
    52.774% 99.504%,
    52.248% 99.682%,
    51.703% 99.821%,
    51.144% 99.921%,
    50.574% 99.98%,
    50% 100%,
    50% 100%,
    49.426% 99.98%,
    48.856% 99.921%,
    48.297% 99.821%,
    47.752% 99.682%,
    47.226% 99.504%,
    46.725% 99.286%,
    46.254% 99.028%,
    45.816% 98.73%,
    45.418% 98.393%,
    45.064% 98.016%,
    7.132% 52.49%,
    7.132% 52.49%,
    5.832% 50.899%,
    4.651% 49.258%,
    3.594% 47.57%,
    2.665% 45.836%,
    1.868% 44.06%,
    1.206% 42.245%,
    0.685% 40.393%,
    0.307% 38.507%,
    0.077% 36.591%,
    0% 34.646%,
    0% 34.646%,
    0.654% 29.027%,
    2.549% 23.696%,
    5.581% 18.725%,
    9.647% 14.185%,
    14.645% 10.148%,
    20.471% 6.685%,
    27.022% 3.867%,
    34.196% 1.766%,
    41.89% 0.453%,
    50% 0%,
    50% 0%,
    58.11% 0.453%,
    65.804% 1.766%,
    72.978% 3.867%,
    79.529% 6.685%,
    85.355% 10.148%,
    90.353% 14.185%,
    94.419% 18.725%,
    97.451% 23.696%,
    99.346% 29.027%,
    100% 34.646%
  );
`

const NoPhoto = styled(ProfileNoImage)`
  background-color: var(--background-surface-2);
`

const Photo = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Position = styled.div`
  display: grid;
  grid-auto-flow: row;
  align-items: center;
  grid-gap: var(--spacing-6px);
  gap: var(--spacing-6px);
  overflow-wrap: anywhere;
`

const Place = styled(Typography)`
  color: var(--foreground-soft);
`
